module.exports = __webpack_public_path__ + "img/csel2.cabf6851.png";